const s = {
  name: "PersonalInformation",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,5c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4s4-1.8,4-4C24,6.8,22.2,5,20,5z M18,9c0-1.1,0.9-2,2-2s2,0.9,2,2
			s-0.9,2-2,2S18,10.1,18,9z"/>
		<path class="st0" d="M14,20c0-1.7,1.3-3,3-3h6c1.7,0,3,1.3,3,3v2h2v-2c0-2.8-2.2-5-5-5h-6c-2.8,0-5,2.2-5,5v2h2V20z"/>
		<path class="st0" d="M5,33v2h30v-2H5z"/>
		<path class="st0" d="M5,31v-2h30v2H5z"/>
		<path class="st0" d="M5,25v2h30v-2H5z"/>
		<path class="st0" d="M0,5c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v30c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5z M5,2C3.3,2,2,3.3,2,5v30
			c0,1.7,1.3,3,3,3h30c1.7,0,3-1.3,3-3V5c0-1.7-1.3-3-3-3H5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PersonalInformation
};
